import React, { useState } from "react";
import { useForm } from "react-hook-form";
import {
  notap_user_roles,
  verification_status_options,
} from "../../../constants/english";
import { useDispatch, useSelector } from "react-redux";
import { postRequest } from "../../../helpers/request";
import { onGetCertificates } from "../../../config/redux/slice/bankUserSlice";

import {
  clearAll,
  setErrorMessageUser,
  setLoadingUser,
} from "../../../config/redux/slice/appSlice";
import { onGetCertificates as onGetCertificatesNotap } from "../../../config/redux/slice/notapUserSlice";
import { onGetCertificates as onGetCertificatesTransferee } from "../../../config/redux/slice/transfereeUserSlice";
import { appApi } from "../../../utils/endpoints/appApi";

export default function CertificateFilter() {
  const dispatch = useDispatch();

  const { userLoading } = useSelector((state) => state.app);

  const {
    token,
    userData: { user_role },
  } = useSelector((state) => state.authData);

  const { register, handleSubmit } = useForm({ mode: "onTouched" });
  // const [filter, setFilter] = useState(notap_user_roles.includes(user_role.toLowerCase()) ? 'pending' : 'all')
  const [filter, setFilter] = useState("all");

  const onSubmit = async (data) => {
    dispatch(clearAll({}));
    let certificate_date =
      data.certificate_date === "" ? "0" : data.certificate_date;
    const res = await postRequest(
      token,
      `${appApi.getCertificates}`,
      { ...data, issuer: "NOTAP", certificate_date },
      dispatch,
      setLoadingUser,
      "",
      setErrorMessageUser
    );
    if (res !== undefined && res.status < 400) {
      if (user_role == "BANK_USER") {
        dispatch(onGetCertificates(res.data.data));
      } else if (user_role == "TRANSFEREE_USER") {
        dispatch(onGetCertificatesTransferee(res.data.data));
      } else {
        dispatch(onGetCertificatesNotap(res.data.data));
      }
    }
  };

  return (
    <div className="card card-default pt-5 px-5 pb-0">
      <div className="formContainer">
        <div className="w-100 pl-3 mb-3">
          <h5 className={`text-capitalize text-dark font-weight-bold`}>
            Filter Confirmation Requests
          </h5>
        </div>
        <form className="w-100" onSubmit={handleSubmit(onSubmit)}>
          <div className="row w-100 m-0">
            <div className="form-group col-sm-6 col-md-5 col-lg-4 mb-4">
              <label htmlFor="certificate_date">Certificate Date</label>
              <input
                type="date"
                className="form-control input-lg"
                id="certificate_date"
                {...register("certificate_date")}
              />
            </div>
            {/* <div className="form-group col-md-4 mb-4">
                    <label htmlFor='issuer'>Issuer</label>
                    <input 
                    type="text" 
                    className="form-control input-lg" 
                    id="issuer" 
                    aria-describedby="issuerHelp"
                    {...register("issuer")}
                    />
                </div> */}
            <div className="form-group col-sm-6 col-md-5 col-lg-4 mb-4">
              <label htmlFor="verification_status">
                Confirmation Request Status
              </label>
              <select
                className="form-control rounded-0"
                id="verification_status"
                defaultValue={filter}
                {...register("verification_status")}
              >
                <option value={""}>Select Status</option>
                {verification_status_options.map((option) => {
                  return (
                    <option key={option.id} value={option.value}>
                      {option.text}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-md-12">
              <button
                disabled={userLoading ? true : false}
                type="submit"
                className="btn btn-sm btn-primary mb-1"
              >
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
